// Copy and classification for the onboard-gateway modal, kept apart from the
// component so the mapping is unit-testable without rendering.
//
// The retailer API (`POST /facilities/{id}/onboard_gateway`) answers:
//   200  { data: [ { ...device } ] }                       completed
//   202  { data: { state: 'pending', serial_number, message } }  held until the gateway comes online
//   404  { error, serial_number }                          unknown serial
//   409  { error, serial_number }                          gateway just came online, retry
//   409  { error }                                         already onboarded
//   502  { error, serial_number }                          registry unreachable / hold failed
//   other 4xx/5xx { error, ... }                           internal failures
// The API wrapper resolves with the body only, so a 202 looks like a 200 from here.

export const GENERIC_ONBOARD_ERROR = 'An error occurred while onboarding the gateway. Please try again.';
export const ALREADY_ONBOARDED = 'This gateway is already onboarded.';
export const HELD_FALLBACK_MESSAGE =
    'This gateway has not connected to Emulate yet. The onboarding has been recorded and will complete automatically once the gateway comes online.';

// 200 answers with `data: [...]`; only the 202 hold answers with an object carrying `state`.
export const isHeldOnboarding = result => result?.data?.state === 'pending';

// Classified by status and by whether the body carries `serial_number`, never by the
// error text. The four serial-carrying branches (unknown serial, just came online,
// registry unreachable, hold failed) were written for retailers and are shown as they
// are. Every other branch's text is internal ("... to BTM", "... Connect index") and
// stays in the logs; the retailer gets the generic message.
export const onboardErrorMessage = err => {
    const status = err?.response?.status;
    const body = err?.response?.data || {};
    const serverError = typeof body.error === 'string' ? body.error : '';
    const serial = typeof body.serial_number === 'string' ? body.serial_number.trim() : '';
    if (body.code === 'already_onboarded' || (status === 409 && !serial)) {
        return ALREADY_ONBOARDED;
    }
    if (serial && serverError) {
        return `Serial number ${serial}: ${serverError}`;
    }
    return GENERIC_ONBOARD_ERROR;
};
